/* Legacy code - ignore complexity errors */
/* eslint complexity: 0 */
import { computed, observable } from 'mobx';
import moment from 'moment';

export default class RelationshipPermission {
  @observable
  id;
  @observable
  relationshipId;
  @observable
  permissionModel;
  @observable
  permissionType;
  @observable
  workspaceId;
  @observable
  appId;
  @observable
  participantId;
  @observable
  itemId;
  @observable
  createdAt;
  @observable
  createdBy;
  @observable
  deletedAt;
  @observable
  deletedBy;
  @observable
  updatedAt;
  @observable
  updatedBy;

  constructor(
    id,
    relationshipId,
    permissionModel,
    permissionType,
    workspaceId,
    appId,
    participantId,
    itemId,
    createdAt,
    createdBy,
    deletedAt,
    deletedBy,
    updatedAt,
    updatedBy
  ) {
    this.id = id || '';
    this.relationshipId = relationshipId || '';
    this.permissionModel = permissionModel || '';
    this.permissionType = permissionType || '';
    this.workspaceId = workspaceId || '';
    this.appId = appId || '';
    this.participantId = participantId || '';
    this.itemId = itemId || '';
    this.createdAt = createdAt || '';
    this.createdBy = createdBy || '';
    this.deletedAt = deletedAt || '';
    this.deletedBy = deletedBy || '';
    this.updatedAt = updatedAt || '';
    this.updatedBy = updatedBy || '';
  }

  @computed
  get createdAtToDate() {
    return moment(this.createdAt).format('MMMM Do YYYY, h:mm a');
  }

  @computed
  get deletedAtToDate() {
    return moment(this.deletedAt).format('MMMM Do YYYY, h:mm a');
  }

  @computed
  get updatedAtToDate() {
    return moment(this.updatedAt).format('MMMM Do YYYY, h:mm a');
  }
}
